// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"def87913","703":"7262ad75"}[chunkId] + ".chunk.js";
};